export default class PeriodSpendings {
  constructor(
    startDate,
    endDate,
    sum
  ) {
    this.startDate = startDate;
    this.endDate = endDate;
    this.sum = sum;
  }

  static createFromData(data) {
    return new PeriodSpendings(
      data.startDate,
      data.endDate,
      data.sum
    )
  }

  static createNew() {
    return new PeriodSpendings(
      null,
      null,
      null
    );
  }
}
